"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apolloClient = void 0;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _unfetch = _interopRequireDefault(require("unfetch"));
var _apolloLinkHttp = require("apollo-link-http");
var _apolloLinkContext = require("apollo-link-context");
var _apolloBoost = require("apollo-boost");
var _store = _interopRequireDefault(require("../store"));
var _utils = require("@/utils");
var _auth = require("../utils/auth");
// import ApolloClient, { InMemoryCache } from 'apollo-boost'

var httpLink = (0, _apolloLinkHttp.createHttpLink)({
  uri: process.env.VUE_APP_HASURA_URI,
  fetch: _unfetch.default
});
var authLink = (0, _apolloLinkContext.setContext)(/*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_, _ref) {
    var headers, token, checkClaim;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          headers = _ref.headers;
          _context.n = 1;
          return _store.default.getters.fbuser.getIdToken();
        case 1:
          token = _context.v.toString();
          checkClaim = (0, _utils.claimTokenInApollo)(token);
          (0, _auth.setClaimToken)(checkClaim);
          return _context.a(2, {
            headers: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, headers), {}, {
              authorization: token ? "Bearer ".concat(token) : ''
            })
          });
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var apolloClient = exports.apolloClient = new _apolloBoost.ApolloClient({
  link: authLink.concat(httpLink),
  cache: new _apolloBoost.InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    }
  }
});